/* eslint-disable no-unused-vars */
import { useQuery } from '@apollo/client'
import { css, StyleSheet } from 'aphrodite'
import api from '../../api'
import dayjs from 'dayjs'
import React, { useEffect, useState, useContext } from 'react'
import Geocode from 'react-geocode'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { IconDownload } from '../../components/Icon'
import UIButtonIcon from '../../components/UI/UIButtonIcon'
import WidgetTable from '../../components/Widget/WidgetTable/WidgetTable'
import config from '../../config'
import GET_ALL_INVOICES from '../../graphql/Invoices/GetInvoices'
import { COLOR_BLACK, COLOR_WHITE } from '../../lib/colors'
import LiveContext from '../../components/Context/LiveContext'

const styles = StyleSheet.create({
  noDataFound: {
    backgroundColor: COLOR_WHITE,
    padding: '20px',
    textAlign: 'center',
  },
  loading: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  underline: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '14px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
  },
  overlay: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    zIndex: '10',
    top: 0,
    left: 0,
    backgroundColor: `${COLOR_BLACK}30`,
  },
  toast: {
    padding: '20px',
    width: 'fit-content',
  },
})

const InvoiceDashboard = () => {
  Geocode.setApiKey(config.GOOGLE_APP_KEY)

  const { t } = useTranslation('translation')
  const [actualPage, setActualPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [tbodyData, setTBodyData] = useState([])
  let navigate = useNavigate()

  const { idWatcher } = useContext(LiveContext)

  const toastId = React.useRef(null)

  const { data: invoiceList, refetch } = useQuery(GET_ALL_INVOICES, {
    variables: {
      first: 10,
      offset: actualPage,
      idWatcher,
    },
    onError: () => {
      toast.error(t('pages.viewerAccount.demand.fetchError'), {
        toastId: 'error',
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    },
  })

  const theadData = [
    t('pages.viewerAccount.invoice.location'),
    t('pages.viewerAccount.invoice.date'),
    t('pages.viewerAccount.invoice.reason'),
    t('pages.viewerAccount.invoice.link'),
    t('pages.viewerAccount.invoice.actions'),
  ]

  useEffect(() => {
    setTBodyData([])
    console.log('fred invoiceList', invoiceList)
    if (invoiceList)
      invoiceList?.invoices?.nodes?.map((item, index) => {
        setTBodyData((prev) => [
          ...prev,
          {
            number: item.invoiceNumber,
            id: item.id,
            items: [
              item?.requestByIdRequest.requestAddress,
              dayjs(item.invoiceDate).format('DD/MM/YYYY'),
              <p key={index}>{item?.requestByIdRequest.title}</p>,
              <span
                key={index}
                className={css(styles.underline)}
                onClick={() => handleIconEye(item)}
              >
                {t('pages.viewerAccount.demand.seeInformations')}
              </span>,
              <UIButtonIcon key={item.id} onClick={() => downloadInvoice(item)}>
                <IconDownload />
              </UIButtonIcon>,
            ],
          },
        ])
      })
  }, [invoiceList])

  useEffect(() => {
    if (
      (tbodyData.length === invoiceList?.invoices?.nodes?.length &&
        invoiceList?.invoices?.nodes?.length > 0) ||
      invoiceList?.invoices?.nodes?.length === 0
    ) {
      setLoading(false)
    }
  }, [tbodyData])

  const handleIconEye = (item) => {
    navigate(`/account/demand/${item?.requestByIdRequest.id}`)
  }

  const downloadInvoice = async (item) => {
    try {
      const toastId = toast.info(t('loading'), { autoClose: false })
      await api.getInvoicesFile(item)
      toast.dismiss(toastId.current)
      toast.success(t('pages.viewerAccount.invoice.downloadStarted'))
    } catch (error) {
      toast.error(t('pages.viewerAccount.demand.fetchError'))
      console.log('invoice error : ', error)
    }
  }

  const fetchData = async () => {
    refetch({
      first: 10,
      offset: actualPage,
      idWatcher,
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      <div>
        {loading ? (
          <div className={css(styles.loading)}>
            {t('pages.viewerAccount.demand.loading')}
          </div>
        ) : (
          <>
            <WidgetTable
              title={t('pages.viewerAccount.invoice.title')}
              theadData={theadData}
              tbodyData={tbodyData.sort((a, b) => b.number - a.number)}
              totalResult={invoiceList?.invoices?.totalCount}
              onClickNext={async () => {
                refetch({
                  first: 10,
                  offset: actualPage + 10,
                  idWatcher,
                })
                setActualPage((prev) => prev + 10)
              }}
              onClickPrevious={async () => {
                refetch({
                  first: 10,
                  offset: actualPage - 10,
                  idWatcher,
                })
                setActualPage((prev) => prev - 10)
              }}
              hasNextPage={invoiceList?.invoices?.pageInfo?.hasNextPage}
              hasPreviousPage={invoiceList?.invoices?.pageInfo?.hasPreviousPage}
            />
            {tbodyData?.length === 0 || !tbodyData ? (
              <div className={css(styles.noDataFound)}>
                {t('pages.viewerAccount.demand.noDataFound')}
              </div>
            ) : null}
          </>
        )}
      </div>
    </>
  )
}

export default InvoiceDashboard
